import { defineStore } from 'pinia';

export const usePageDataStore = defineStore('pageData', {
  state: () => ({
    pageData: null,
  }),
});
